module.exports = __webpack_public_path__ + "img/appBarFinish.8509f641.png";